var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMPointIconBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9878",
    "data-name": "Group 9878",
    transform: "translate(-5337 1512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_10",
    "data-name": "Exclusion 10",
    d: "M32,64A32.008,32.008,0,0,1,19.544,2.515a32.008,32.008,0,0,1,24.911,58.97A31.8,31.8,0,0,1,32,64ZM32,5A27,27,0,1,0,59,32,27.031,27.031,0,0,0,32,5Z",
    transform: "translate(5337 -1512)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_11",
    "data-name": "Exclusion 11",
    d: "M27,54A27.007,27.007,0,0,1,16.49,2.122,27.007,27.007,0,0,1,37.51,51.878,26.832,26.832,0,0,1,27,54Zm4.649-31.389h0V35h2.955V19.252h-4.77L27.011,29.994,24.153,19.252H19.394V35h2.955V22.6L25.464,35h3.062Z",
    transform: "translate(5342 -1507)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMPointIconBold);
export default __webpack_public_path__ + "static/media/M_Point_icon_bold.2b5b0ce4.svg";
export { ForwardRef as ReactComponent };